import { useDocumentTitle } from '@/hooks/document-title'
import { useLoaderData } from 'react-router'
import { ExternalCheckoutView } from '@/features/billing/external-checkout/ExternalCheckoutView'

export default function ExternalCheckoutViewContainer() {
  useDocumentTitle('Checkout')

  const data = useLoaderData<{ error?: boolean }>()

  return <ExternalCheckoutView error={!!data?.error} />
}
